import { render, staticRenderFns } from "./Trash.view.vue?vue&type=template&id=7543764a&scoped=true"
import script from "./Trash.view.vue?vue&type=script&lang=js"
export * from "./Trash.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7543764a",
  null
  
)

export default component.exports